export const siteKey = process.env.REACT_APP_GOOGLE_SITE_KEY;
export const termofService = 'https://www.gupshup.io/terms-and-conditions';
export const privacyPolicy = 'https://www.gupshup.io/privacy-policy';

export const NOT_EXISTS = 'NOT_EXISTS';
export const NOT_VERIFIED = 'not_verified';
export const RESET_EMAIL = 'reset_email';
export const VERIFY_EMAIL = 'verify_email';
export const VERIFY_INVITE = 'verify_invite';
export const MESSAGE = 'message';
export const CONSOLE = 'console';
export const TEMPLATE = 'template';
export const AUTH_FLOW = 'authflow';
export const DOMAIN = '.gupshup.io';
export const VERIFIED =
  'Your email was verified. You can continue using the application.';
export const ALREADY_VERIFIED = 'This account is already verified.';
export const URL_EXPIRED = 'This URL can be used only once';
export const PASSWORD_CHANGED = 'password_changed';
export const INVALID_USER_ERROR = 'invalid_user_error';
export const TOKEN_INVALID = 'token_invalid';
export const TOKEN_EXPIRED = 'token_expired';
export const VERIFY_LINK_EXPIRED = 'verify_link_expired';
export const ACCESS_EXPIRED = 'Access expired.';
export const VERIFICATION_SEND = 'verification_send';
export const INVALID_CREDENTIAL = 'INVALID_CREDENTIAL';
export const SUCCESS_TOKEN = 'SUCCESS_TOKEN';
export const REQUEST_FAILED = 'request_failed';
export const REASON = 'reason';
export const USER_EXISTS = 'user_exists';
export const INVALID_OR_EXPIRED_TOKEN = 'invalid_or_expired_token';
export const SUCCESS = 'SUCCESS';
export const FAIL = 'fail';
export const WARNING = 'WARNING';
export const RESET_LINK = 'RESET_LINK';
export const REFERRAL_DETAIL = 'REFERRAL_DETAIL';
export const COMPANY_DETAIL = 'COMPANY_DETAIL';
export const TYPE_SALES = 'SALES';
export const DIRECT = 'DIRECT';
export const REFERRAL = 'referral';
export const GOOGLE = 'google';
export const GOOGLE_AUTH2 = 'google-oauth2';
export const DATABASE_CONNECTION = 'Username-Password-Authentication';
export const ON_CHANGE = 'onChange';
// forms constant
export const CAPTCHA = 'captcha';
export const CONFIRM_PASSWORD = 'confirmpassword';
export const ACCEPT_TERMS = 'acceptTerms';
export const EMAIL = 'email';
export const REFERRAL_CODE = 'refCode';
export const USER_TYPE = 'userType';
export const COMPANY_NAME = 'companyName';
export const COUNTRY = 'country';
export const TOTAL_EMPLOYEES = 'numOfEmployees';

export const SOURCE = 'source';
export const LOGIN = 'login';
export const SIGNUP = 'signup';
export const LANG_PREF = 'gs_lang_pref';
export const FORGOT_PASSWORD = 'forgot_password';
export const SIGNUP_SUCCESS = 'signup_success';
export const INVITE_ACCEPTED = 'invite_accepted';
export const PORTAL_DENIED = 'portal_denied';

export const AUTHORIZE_PARAMS = [
  'prompt',
  'redirect_uri',
  'lang',
  'source',
  'email',
  'template'
];

export const LANGUAGES = [
  { id: 'en', name: 'English', label: 'EN' },
  { id: 'es', name: 'Spanish', label: 'ES' },
  { id: 'pt', name: 'Portuguese', label: 'PT' }
];
export const CONSOLE_OPTIONS = [
  {
    id: 1,
    name: 'google',
    displayText: 'Sign up with Google',
    icon: 'icons/google.png'
  }
];
export const PROVIDERS = [
  {
    id: 1,
    name: 'google',
    displayText: 'Sign up with Google',
    icon: 'icons/google.png'
  },
  {
    id: 2,
    name: 'facebook',
    displayText: 'Sign up with Facebook',
    icon: 'icons/facebook.svg'
  },
  {
    id: 3,
    name: 'github',
    displayText: 'Sign up with Github',
    icon: 'icons/github.svg'
  }
];

export const AlertConfig = {
  [NOT_VERIFIED]: {
    status: 'warning',
    title: 'not_verified_title',
    icon: 'icon-warning',
    link: '',
    text: 'not_verified_text'
  },
  [INVALID_CREDENTIAL]: {
    status: 'error',
    icon: 'ic-error',
    title: 'invalid_credential_title',
    text: 'invalid_credential_text'
  },
  [ALREADY_VERIFIED]: {
    status: 'success',
    icon: 'ic-success',
    link: '',
    title: 'already_verified_title',
    text: 'already_verified_text'
  },
  [VERIFY_LINK_EXPIRED]: {
    status: 'error',
    icon: 'ic-error',
    title: 'verify_link_expired_title',
    text: ''
  },
  [URL_EXPIRED]: {
    status: 'error',
    icon: 'ic-error',
    link: 'click_here',
    title: 'url_expired_title',
    text: 'url_expired_text'
  },
  [REQUEST_FAILED]: {
    status: 'error',
    icon: 'ic-error',
    title: 'request_failed_title',
    text: 'request_failed_text'
  },
  [INVALID_USER_ERROR]: {
    status: 'error',
    icon: 'ic-error',
    title: 'invalid_user_error_title',
    text: 'invalid_user_error_text'
  },
  [TOKEN_INVALID]: {
    status: 'error',
    icon: 'ic-error',
    title: 'token_invalid_title',
    text: ''
  },
  [TOKEN_EXPIRED]: {
    status: 'error',
    icon: 'ic-error',
    title: 'token_expired_title',
    text: 'token_expired_text'
  },
  [PORTAL_DENIED]: {
    status: 'error',
    icon: 'ic-error',
    title: 'portal_denied_title',
    text: 'portal_denied_text'
  },
  [VERIFIED]: {
    status: 'success',
    icon: 'ic-success',
    title: 'verified_title',
    text: 'verified_text'
  },
  [VERIFICATION_SEND]: {
    status: 'success',
    icon: 'ic-success',
    title: 'verification_send_title',
    text: 'verification_send_text'
  },
  [PASSWORD_CHANGED]: {
    status: 'success',
    icon: 'ic-success',
    title: 'password_changed_title',
    text: 'password_changed_text'
  },
  [RESET_LINK]: {
    status: 'success',
    icon: 'ic-success',
    title: 'reset_link_title',
    text: 'reset_link_text'
  },
  [SIGNUP_SUCCESS]: {
    status: 'success',
    icon: 'ic-success',
    title: 'signup_success_title',
    text: 'signup_success_text'
  },
  [INVITE_ACCEPTED]: {
    status: 'success',
    icon: 'ic-success',
    title: 'invite_accepted_title',
    text: 'invite_accepted_text'
  }
};
